import React from 'react';
import { type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, useSettings, Utils } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { renderCellWithTooltip, renderDate } from 'app/main/components/page-layouts/view/table/ViewTableUtils';

interface UsersReadReceiptsTabProps {
	userUid: string;
	refresh: boolean;
	updateRefresh: VoidFunction;
}

export default function UsersReadReceiptsTab({ userUid, refresh, updateRefresh }: UsersReadReceiptsTabProps) {
	const { t } = useSettings();

	const columns: GridColDef[] = [
		{
			field: 'coms_title',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_COMMUNICATION'),
			minWidth: 200,
			flex: 4,
			renderCell: ({ value, row }) => renderCellWithTooltip({ value }),
			sortable: false,
			hideable: false
		},
		{
			field: 'cmrd_read',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_READ'),
			minWidth: 100,
			flex: 1,
			renderCell: ({ value }) =>
				value ? <Icon icon="check" color="green" /> : <Icon icon="close" color="red" />,
			sortable: false,
			hideable: false
		},
		{
			field: 'cmrd_d_read',
			headerName: t('DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_DATE'),
			minWidth: 100,
			flex: 1,
			renderCell: ({ value }) =>
				value ? (
					renderDate({
						value,
						format: {
							year: 'numeric',
							month: '2-digit',
							day: '2-digit',
							hour: '2-digit',
							minute: '2-digit',
							second: '2-digit'
						}
					})
				) : (
					<></>
				),
			sortable: false
		}
	];

	return (
		<ViewTable
			module="communications_readreceipts"
			columns={columns}
			defaultFilters={[
				{ filt_field: 'coms_deleted', filt_clause: 'not_equal', filt_value: 1 },
				{ filt_field: 'coms_readnotification', filt_clause: 'equals', filt_value: 1 },
				{ filt_field: 'user_uid', filt_clause: 'equals', filt_value: userUid }
			]}
			refresh={refresh}
			updateRefresh={updateRefresh}
		/>
	);
}
